import { useMemo } from "react";
import { Modal } from "@mantine/core";
import { PortalSubjectType } from "../../../services/admin/portalAccess.service";
import {
  AddPortalGrantForm,
  AddGrantMode,
  PrimaryDefaults,
} from "./AddPortalGrantForm";

export type { PrimaryDefaults } from "./AddPortalGrantForm";

interface AddPortalGrantModalProps {
  opened: boolean;
  onClose: () => void;
  subjectType: PortalSubjectType;
  subjectId: string;
  subjectName?: string;
  mode?: AddGrantMode;
  primaryDefaults?: PrimaryDefaults;
}

export function AddPortalGrantModal({
  opened,
  onClose,
  subjectType,
  subjectId,
  subjectName,
  mode = "additional",
  primaryDefaults,
}: AddPortalGrantModalProps) {
  const titleText = useMemo(() => {
    const suffix = subjectName ? ` — ${subjectName}` : "";
    return mode === "primary"
      ? `Invite Primary Contact${suffix}`
      : `Add Contact${suffix}`;
  }, [mode, subjectName]);

  const formKey = `${subjectId}::${mode}::${opened ? "open" : "closed"}`;

  return (
    <Modal.Root
      opened={opened}
      onClose={onClose}
      closeOnClickOutside={false}
      size="lg"
      centered
      styles={{
        content: {
          display: "flex",
          flexDirection: "column",
          maxHeight: "85vh",
        },
      }}
    >
      <Modal.Overlay />
      <Modal.Content>
        <Modal.Header>
          <Modal.Title>{titleText}</Modal.Title>
          <Modal.CloseButton />
        </Modal.Header>
        <AddPortalGrantForm
          key={formKey}
          subjectType={subjectType}
          subjectId={subjectId}
          mode={mode}
          primaryDefaults={primaryDefaults}
          onClose={onClose}
        />
      </Modal.Content>
    </Modal.Root>
  );
}
